<template>
	<div class="box">
		<div class="top">
			<h2 class="top_title">在海量原创、可商用模板中快速搜索</h2>
			<div class="top_input">
				<a-input-search class="input_search" v-model:value="getData.keyword" placeholder="请输入模板关键词" enter-button="搜索模板" size="large" @search="onSearch" allowClear>
					<template #prefix>
						<svg width="16" height="16" class="icon_search">
							<path
								d="M14.7 13.4l-2-2c1.9-2.6 1.7-6.2-.6-8.5C10.9 1.6 9.2 1 7.5 1s-3.3.6-4.6 1.9C.3 5.5.3 9.6 2.9 12.1 4.2 13.4 5.8 14 7.5 14c1.4 0 2.8-.4 3.9-1.3l2 2c.4.4 1 .4 1.3 0 .4-.3.4-.9 0-1.3zm-7.2-1.2c-1.2 0-2.4-.5-3.3-1.4-1.8-1.8-1.8-4.7 0-6.6.9-.9 2.1-1.4 3.3-1.4s2.4.5 3.3 1.4c1.8 1.8 1.8 4.8 0 6.6-.8.9-2 1.4-3.3 1.4z">
							</path>
						</svg>
					</template>
				</a-input-search>
				<span class="top__tip_7s">或</span>
				<a-button type="primary" size="large" class="top__tip_btn" @click="skipEdit">开始制作</a-button>
			</div>
			<div class="top_hot">
				<svg width="14" height="16" class="SearchSection_searchInputBox__searchIcon__yL7re">
					<defs>
						<linearGradient x1="50%" y1="-8.254%" x2="50%" y2="129.102%" id="hot_svg__a">
							<stop stop-color="#FFEA3F" offset="0%"></stop>
							<stop stop-color="#FF4555" offset="100%"></stop>
						</linearGradient>
					</defs>
					<path d="M6.834.099C2.897 3.147 5.017 8.153 5.017 8.153 4.118 7.79 3.176 6.02 3.033 4.975a.464.464 0 00-.792-.271C1.383 5.576.011 7.669 0 10.019v.05c.005 1.228.384 2.523 1.403 3.75 2.81 3.384 9.702 2.822 11.244-1.63a6.222 6.222 0 00.353-2.01v-.074c-.021-3.417-2.974-5.947-4.225-6.775C7.855 2.72 7.685 1.47 7.69.6 7.691.266 7.41 0 7.12 0a.459.459 0 00-.285.099"
						fill="url(#hot_svg__a)" fill-rule="evenodd"></path>
				</svg>
				<span>热门推荐：</span>
				<a v-for="(item,index) in hotKeywordList" :key="index" @click="onSearch(item.keyword)">{{item.keyword}}</a>
			</div>
		</div>
		<div class="classify">
			<div class="classify_content">
				<div class="classify_search">
					<div class="classify_box" v-for="(item,index) in classifyList">
						<span class="title-name">{{item.title}}：</span>
						<ul ref="ul" :style="{'overflow':showBox[index],'height':height[index]}">
							<li v-for="(items,indexs) in item.list" :key="indexs" @click="select(index,items.id)">
								<span :class="getData[item.type]==items.id?'li_style':''">{{items.name}}</span>
							</li>
						</ul>
						<span class="more" v-if="showMore[index]" @click="expand(index)">
							{{height[index]=='auto' ? '收起' : '更多'}}
							<i :class="['mbm-iconfont', height[index]=='auto'?'mbm-shangjiantou':'mbm-xiajiantou1']"></i>
						</span>
					</div>
				</div>
				<h2 class="thread"></h2>
				<div class="sort">
					<ul>
						<li :class="sortIndex==index?'sort_li_style':''" v-for="(item,index) in sortList" :key="index"
							@click="sortChange(index,item.way)">{{ item.title }}</li>
					</ul>
					<span class="horizontal"></span>
					<span class="title-name">类型：</span>
					<a-radio-group name="radioGroup" style="display: flex;" v-model:value="getData.need_to_pay"
						@change="getMasterplateList">
						<a-radio value="">全部</a-radio>
						<a-radio value="0">免费</a-radio>
						<a-radio value="1">会员</a-radio>
					</a-radio-group>
				</div>
			</div>
		</div>
		<div  class="data-box-loading" v-if="loading"><a-spin /></div>
		<div class="masterplate">
			<div class="tag-tpls" v-if="init==1">
				<div class="tag-tpls-box" v-for="(tag,tagIndex) in recomTagTpls" :key="tag.id">
					<div class="tag-tpls-box-title">
						<span>{{tag.name}}</span>
						<text v-if="tag.intro" class="tag-tpls-box-title-line">|</text>
						<text v-if="tag.intro">{{tag.intro}}</text>
					</div>
					<div class="masterplate">
						<div class="masterplate_box" v-for="(item,index) in tag.childs" :key="item.id">
							<div class="masterplate_box_img">
								<img :src="$baseFunc.getAliOssAuthKey(item.cover,true)+'&x-oss-process=image/resize,w_750'">
								<div class="shade">
									<div class="preview">
										<a :href="item.detail_url" target="_blank">预览</a>
									</div>
									<div class="use" @click.stop="showConfirm(item)">使用此模板</div>
								</div>
							</div>
							<div target="_blank" class="masterplate_box_text">
								<span :class="item.need_to_pay==0?'copyrightBtn_tip_box_save_free':'copyrightBtn_tip_box_save'">{{item.need_to_pay==0?'免费模板':'会员模板'}}</span>
								<a :href="item.detail_url" class="title">{{item.title}}</a>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="masterplate_box" v-else v-for="(item,index) in masterplateList" :key="index">
				<div class="masterplate_box_img">
					<img :src="$baseFunc.getAliOssAuthKey(item.cover,true)+'&x-oss-process=image/resize,w_750'">
					<div class="shade">
						<div class="preview">
							<a :href="item.detail_url" target="_blank">预览</a>
						</div>
						<div class="use" @click.stop="showConfirm(item)">使用此模板</div>
					</div>
				</div>
				<div target="_blank" class="masterplate_box_text">
					<span :class="item.need_to_pay==0?'copyrightBtn_tip_box_save_free':'copyrightBtn_tip_box_save'">{{item.need_to_pay==0?'免费模板':'会员模板'}}</span>
					<a :href="item.detail_url" class="title">{{item.title}}</a>
				</div>
			</div>
		</div>
		<div class="empty-null-data-box" v-if="init!=1 && !loading && masterplateList.length<1">
			<img src="/img/empty-data-01.png?t=1.0.0" alt="">
			<div>{{getData.keyword?'没有搜索到结果，请尝试重新输入相关关键词搜索。':'没有数据'}}</div>
		</div>
		<div class="paging" v-if="init!=1">
			<a-pagination v-model:current="getData.page" hideOnSinglePage v-model:pageSize="getData.size" :total="total" @change="pagingChabge" />
		</div>
	</div>
</template>

<script>
	import {
		message,
		Modal
	} from 'ant-design-vue';
	import baseFunc from "../../config/base_func";
	import config from "/src/config/config.js";
	export default {
		data() {
			return {
				init:1,
				ulWidth: 0,
				liLength: 0,
				showMore: [false, false, false], //是否显示更多
				showBox: ["hidden", "hidden", "hidden"], //是否隐藏分类多余的
				height: ['29px', '29px', '29px'], //分类高度
				classifyList: [], //分类列表
				recomTagTpls:[],//模板分类数据
				masterplateList: [], //模板列表
				hotKeywordList: [], //热搜词
				sortList: [
					{
						title:'综合排序',
						way:'',
					},
					{
						title:'最新上传',
						way:'new',
					},
					{
						title:'热门推荐',
						way:'hot',
					},
				], //排序列表
				sortIndex: 0, //排序下标
				getData: { //请求数据
					scene_id: "", //场景id  
					trade_id: "", //行业id  
					feature: "", //功能 
					need_to_pay: "", //用户等级
					keyword: "", //关键词
					sort_name: "", //排序字段
					page: 1,
					size: 50,
				},
				total: 0, //总条数
				loading:false,
				
			}
		},
		created() {
			if(scene_id>-1 || trade_id>-1)this.init = 0;
			this.getData.scene_id = scene_id<0?0:scene_id
			this.getData.trade_id = trade_id<0?0:trade_id
				
			this.getRecomTagTpls()//查询分类模板
			this.getMasterplateList(1)
			this.getInitClassifyList()
			this.getHotKeywordList()
		},
		methods: {
			getRecomTagTpls(){
				this.$apiRequest.post('/template/getRecomTagTpls', {
					way:1,
				}).then(res => {
					this.loading=false;
					this.recomTagTpls = res.data.data;
				}).catch(err => {
				})
			},
			//获取模板列表
			getMasterplateList(state) {
				if(this.loading)return false;
				this.loading=true;
				this.masterplateList=[];
				if(state!=1)this.init = 0;
				this.$apiRequest.post('/template/getTemplateLists', this.getData).then(res => {
					this.masterplateList = res.data.data.data
					this.total = res.data.data.total
					this.loading=false;
				}).catch(err => {
					this.loading=false;
					// message.error(err.data.message);
				})
			},
			//获取分类列表
			getInitClassifyList() {
				this.$apiRequest.get('/template/getTemplateTypes').then(res => {
					this.classifyList = res.data.data
					this.$nextTick(() => {
						this.judgeMore()
					})
				}).catch(err => {
					// message.error(err.data.message);
				})
			},
			//获取热搜词
			getHotKeywordList() {
				this.$apiRequest.get('/template/getHotKeywords').then(res => {
					this.hotKeywordList = res.data.data
				}).catch(err => {
					if(err.data)baseFunc.checkState(err.data);
				})
			},
			//展开分类
			expand(index) {
				this.showBox[index] = this.showBox[index] == 'inherit' ? 'hidden' : 'inherit'
				this.height[index] = this.height[index] == 'auto' ? '29px' : 'auto'
			},
			//判断是否有更多
			judgeMore() {
				// 获取ul元素
				const els = this.$refs.ul
				els.forEach((item, index) => {
					// 获取ul宽度
					this.ulWidth = item.offsetWidth
					// 获取li元素
					const lis = item.getElementsByTagName('li')
					// 获取li元素长度
					this.liLength = lis.length
					// 计算li宽度
					let totalWidth = 0
					Array.prototype.forEach.call(lis, (item, index) => {
						totalWidth += item.offsetWidth
					})
					// 如果li宽度大于ul宽度，则显示更多按钮
					if (totalWidth > this.ulWidth) {
						this.showMore[index] = true
					}
				});
			},
			//筛选
			select(index, id) {
				switch (index) {
					case 0:
						if(config.devEnv=='online'){
							if(!id)id=0;
							window.location.href=`https://www.wwei.cn/moban-${id}-0`;
							return false;
						}else{
							this.getData.scene_id = id
							this.getData.trade_id = 0
						}
						break;
					case 1:
						if(config.devEnv=='online'){
							if(!id)id=0;
							window.location.href=`https://www.wwei.cn/moban-0-${id}`;
							return false;
						}else{
							this.getData.scene_id = 0
							this.getData.trade_id = id
						}
						break;
					case 2:
						this.getData.feature = id
						break;
				}
				this.getData.page = 1
				this.getMasterplateList()
			},
			//排序
			sortChange(index,way) {
				this.sortIndex = index
				this.getData.sort_name = way;
				this.getData.page = 1
				this.getMasterplateList()
			},
			//查找
			onSearch(value) {
				this.getData.keyword = value
				this.getData.page = 1
				this.getData.scene_id = 0
				this.getData.trade_id = 0
				this.getData.feature = 0
				this.getMasterplateList()
			},
			//页码改变
			pagingChabge(page, pageSize) {
				this.getData.page = page
				this.getData.size = pageSize
				this.getMasterplateList()
			},
			//弹出框
			async showConfirm(item) {
				if(item.need_to_pay==1){
					await this.$apiRequest.post('/template/getUseUrl', {
						id:item.id
					}).then(res => {
						window.open(res.data.data.use_url);
					}).catch(err => {
						baseFunc.checkState(err.data)
					})
				}else{
					window.open(config.editDomain+'/gedit/'+item.id);
				}
			},
			skipEdit(){
				window.open(config.editDomain+'/gedit');
			}
		},
		computed: {}
	}
</script>

<style scoped lang="scss">
	.box {
		.top {
			position: relative;
			width: 1200px;
			margin: 0 auto;
			padding-top: 50px;
			.top_title {
				font-size: 32px;
				line-height: 48px;
				margin: 0 auto 38px;
				text-align: center;
				font-weight: bold;
				color: #303133;
			}

			.top_input {
				display: flex;
				align-items: center;
				justify-content: center;
				width: auto;
				max-width: 992px;
				height: 54px;
				margin: 0 auto;

				.input_search {
					height: 100%;
					.icon_search {
						margin-right: 5px;
						fill: #D4D6DC;
					}
					/deep/ .ant-input-clear-icon{font-size: 16px;}
					/deep/.ant-input-affix-wrapper:hover {
						border-color: #09BD71;
						border-right-width: 1px;
					}

					/deep/.ant-input-affix-wrapper {
						border-color: #09BD71;
						border-right-width: 1px;
						box-shadow:none !important;
					}

					/deep/.ant-input-search {
						width: 660px;
						height: 54px;
						padding: 6.5px 16px;
						font-size: 16px;
						border-radius: 8px 0 0 8px;
						border-width: 2px;
					}

					/deep/.ant-input-search-button {
						width: 128px;
						height: 54px;
						font-size: 16px;
						background-color: #09BD71;
						border-color: #09BD71;
						border-radius: 0 8px 8px 0;
					}
				}
				
				.top__tip_7s{
					font-size: 18px;
					font-weight: 800;
					color: #303133;
					margin: 0 24px;
				}
				.top__tip_btn{
					width: 138px;
					min-width: 138px;
					border-radius: 8px;
					line-height: 1;
					height: 54px;
				}
			}

			.top_hot {
				margin-top: 20px;
				margin-left:186px;
				span {
					font-size: 14px;
					line-height: 19px;
					color: #5a5f69;
					text-align: center;
					margin-left: 6px;
				}

				a {
					padding: 0 8px;
					color: #9da2ad;
				}
			}
		}

		.classify {
			width: 1200px;
			height: auto;
			margin: 65px auto 30px;
			padding: 0px;
			border-radius: 12px;
			min-height: 240px;
			// background: linear-gradient(180deg, rgba(44,213,143,0.35), rgb(181,227,207));
			.classify_content {
				width: 1200px;
				height: auto;
				background: rgb(255, 255, 255);
				box-shadow: 0px 6px 25px 0px rgba(215,227,222,0.5);
				border-radius: 12px 12px 12px 12px;
				opacity: 1;
				margin: 0 auto;

				.classify_search {
					padding-top: 25px;
					padding-bottom: 6px;
					min-height: 178px;
					.classify_box {
						position: relative;
						padding: 0;
						min-width: 1200px;
						padding-top: 6px;
						box-sizing: border-box;
						margin: 0 auto;
						display: flex;
						margin-bottom: 14px;
						.title-name {
							border: 0 solid #000000;
							font-weight: 500 !important;
							color: #1F1A1B !important;
							margin-left: 26px;
							font-size: 14px;
							display: inline-block;
							margin-right: 5px;
							line-height: 26px;
							width: 42px;
						}
						ul {
							width: 1060px;
							overflow: hidden;
							li {
								margin-bottom: 14px;
								line-height: 25px;
								cursor: pointer;
								float: left;
								span {
									padding: 3px 14px;
									font-size: 14px;
									color: #5F625F;
									transition: color 0.3s;
								}
							}
							li:hover span{
								color: #09BD71;
							}

							.li_style {
								background: #e2f8e9 !important;
								border-radius: 34px 34px 34px 34px;
								color: #09BD71;
							}
						}

						.more {
							line-height: 26px;
							font-size: 14px;
							cursor: pointer;
							display: inline !important;
						}

						.more:hover {
							color: #09BD71;
						}
					}
				}

				.thread {
					width: 1148px;
					height: 1px;
					background: #e2f8e9;
					margin: 0 auto;
					margin-top: 6px;
					margin-bottom: 15px;
				}

				.sort {
					display: flex;
					align-items: center;
					margin-left: 26px;
					padding-bottom: 18px;

					ul {
						display: flex;

						li {
							padding: 0 12px;
							font-size: 14px;
							display: flex;
							align-items: center;
							cursor: pointer;
							font-weight: 500;
						}
						li:nth-child(1) {
							padding-left: 0;
						}
						.sort_li_style {
							color: #09BD71;
						}
					}

					.horizontal {
						display: inline-block;
						margin-top: 9px;
						width: 2px;
						height: 16px;
						background: #e2f8e9;
						margin: auto 0;
					}

					.title-name {
						margin-left: 10px;
					}

					/deep/.ant-radio-inner {
						border: 1px solid #09BD71;
					}

					/deep/.ant-radio-inner::after {
						background-color: #09BD71;
						border-radius: 0;
						width: 100%;
						height: 100%;
						top: 0;
						left: 0;
						content: '\2713';
						color: #fff;
						display: flex;
						justify-content: center
					}

					/deep/.ant-radio-inner {
						border-radius: 0;
					}

					/deep/.ant-radio-wrapper {
						display: flex;
						align-items: center;
					}
				}
			}
		}
		.tag-tpls-box{
			.tag-tpls-box-title{
				display: flex;
				align-items: flex-end;
				justify-content: flex-start;
				line-height: 1.5;
				margin: 32px 0 32px;
				span{
					font-size: 24px;
					color:#303133;
					font-weight: bold;
				}
				.tag-tpls-box-title-line{margin: 0 12px;}
				text{
					font-size: 21px;
					color:#666666;
					font-weight: normal;
				}
			}
		}
		.masterplate {
			width: 1200px;
			height: auto;
			margin: 0 auto;
			display: flex;
			flex-wrap: wrap;

			.masterplate_box {
				clear: both;
				margin-right: 30px;
				-webkit-transition: all 0.3s;
				-o-transition: all 0.3s;
				transition: all 0.3s;
				position: relative;
				cursor: pointer;
				.masterplate_box_img {
					width: 216px;
					position: relative;
					height: 430px;
					overflow: hidden;
					border-radius: 10px;
					cursor: pointer;
					border:1px solid rgba(236, 236, 236, 1);
					box-shadow: 0px 0px 5px 0px rgba(219,219,219,0.5);
					img {
						width: 100%;
						border-radius: 10px;
						image-rendering: -webkit-optimize-contrast;
					}
					.shade {
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
						height: 100%;
						background-color: rgba(0, 0, 0, .2);
						z-index: 20;
						display: none;
						border-radius: 10px;

						.preview {
							position: absolute;
							top: 50%;
							left: 50%;
							transform: translate(-50%, -50%);
							border-radius: 4px;
							line-height: 28px;
							font-size: 14px;
							background: #09bd71;
							text-align: center;
							transition: all 0.2s;
							width: 60px;
							cursor: pointer;
							a {
								color: #fff;
								width: 100%;
								height: 100%;
								align-items: center;
								display: flex;
								justify-content: center;
							}
						}
						.preview:hover{
							background: linear-gradient(90deg,#09bd71,#37ca8c);
						}

						.use {
							position: absolute;
							bottom: 0;
							left: 50%;
							transform: translate(-50%, 0%);
							background-color: #09bd71;
							font-size: 14px;
							line-height: 38px;
							font-weight: 600;
							z-index: 10;
							color: #fff;
							width: 100%;
							text-align: center;
							border-bottom-right-radius: 10px;
							border-bottom-left-radius: 10px;
							cursor: pointer;
							-webkit-transition: all 0.3s;
							-o-transition: all 0.3s;
							transition: all 0.3s;
							a {
								color: #fff;
							}
						}
						.use:hover,.preview:hover{
							background: linear-gradient(90deg,#09bd71,#37ca8c);
						}
					}
				}

				.masterplate_box_text {
					display: flex;
					align-items: center;
					margin-top: 10px;
					margin-bottom: 32px;

					.title {
						box-sizing: border-box;
						margin-left: 5px;
						width: 130px;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
						color:rgba(0, 0, 0, 0.85);
					}

					.copyrightBtn_tip_box_save {
						display: block;
						// width: 64px;
						padding: 0 10px;
						height: 22px;
						background: linear-gradient(133deg, #FF0909 0%, #FFA96A 100%);
						border-radius: 1px;
						font-size: 12px;
						line-height: 22px;
						color: #fff;
						border-radius: 10px 0px 8px 0px;
						margin-top: -2px;
					}

					.copyrightBtn_tip_box_save_free {
						display: block;
						// width: 64px;
						padding: 0 10px;
						height: 22px;
						border-radius: 1px;
						font-size: 12px;
						line-height: 22px;
						margin-top: -2px;
						border-radius: 10px 0px 8px 0px;
						background: linear-gradient(132deg, #9CE006 0%, #00D828 100%);
						box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
						color: #ffffff;
					}
				}
			}
			.masterplate_box:hover{
				transform: translateY(-9px);
			}
			.masterplate_box:hover .masterplate_box_img .shade {
					display: block;
			}
			.masterplate_box:nth-child(5n) {
				margin-right: 0;
			}
		}

		.paging {
			width: 1200px;
			padding-bottom: 20px;
			margin: 0 auto;
			text-align: center;
		}
		.data-box-loading{
			margin: 85px auto;
			text-align: center;
		}
		.empty-null-data-box{
			margin: 85px auto 242px;
			text-align: center;
			img{
				max-width: 500px;
			}
			div{
				margin-top: 24px; 
				color: #666666; 
				font-size: 14px;
				margin-right: 90px;
			}
		}
	}

	.mbm-gantanhao11-copy {
		color: #FFA96A;
		font-size: 28px;
		margin-right: 8px;
	}

	ul,
	ol,
	li {
		list-style: none;
		padding: 0;
		margin: 0;
	}
</style>
<style lang="scss">
	.input_search .ant-input-lg {
		font-size: 14px;
	}

	.input_search input::-webkit-input-placeholder {
		font-size: 14px;
	}

	.input_search input::input-placeholder {
		font-size: 14px;
	}
</style>